import { useMemo } from 'react';
import { ChartData, TypeGroup, InvestmentType, RiskLevel } from '../types/assetAllocation';
import useCopilotValueStore from '@/stores/copilotValueStore';

// 根据类型映射颜色
const getTypeColor = (type: InvestmentType): string => {
  switch (type) {
    case '进取投资':
      return '#5959EB';
    case '稳健投资':
      return '#FF7B52';
    case '现金管理':
      return '#EB2F96';
    default:
      return '#8C8C8C';
  }
};

// 根据风险等级获取标签颜色
const getRiskLevelColor = (level: RiskLevel): string => {
  switch (level) {
    case 'R1':
      return 'green';
    case 'R2':
      return 'blue';
    case 'R3':
      return 'orange';
    case 'R4':
      return 'red';
    case 'R5':
      return 'red';
    default:
      return 'gray';
  }
};

// 风险等级映射
const mapLevelToHeader = (level: RiskLevel): string => {
  switch (level) {
    case 'R1':
      return '低风险稳健';
    case 'R2':
      return '中低风险';
    case 'R3':
      return '中风险';
    case 'R4':
      return '中高风险';
    case 'R5':
      return '高风险';
    default:
      return '未知风险';
  }
};

export const useAssetAllocationCharts = () => {
  const { copilotValue4 } = useCopilotValueStore();
  // 处理图表数据
  const chartData = useMemo((): ChartData[] => {
    const filteredData = copilotValue4?.filtered || [];

    // 根据类型分组并计算总比例
    const typeGroups = filteredData.reduce((acc: Record<string, TypeGroup>, item) => {
      if (!acc[item.type]) {
        acc[item.type] = {
          type: item.type,
          totalProportion: 0,
          color: getTypeColor(item.type as InvestmentType)
        };
      }
      acc[item.type].totalProportion += parseFloat((item.proportion || '').replace('%', ''));
      return acc;
    }, {});

    return Object.values(typeGroups).map(group => ({
      name: group.type,
      value: group.totalProportion,
      color: group.color
    }));
  }, [copilotValue4]);

  return {
    chartData,
    getTypeColor,
    getRiskLevelColor,
    mapLevelToHeader
  };
};
